/**
 * DEV-1160. Переводы экрана «Импорт из Drive» (эпик DEV-1075, ADR-0038).
 *
 * Отдельным модулем, как propertyForm/propertyUnits: правки импорта не конфликтуют с общим
 * ru.ts, который правят все подряд.
 */

const ruDriveImport = {
  title: 'Импорт проектов из Google Drive',
  rootFolder: 'Папка «Database»',
  access: 'Доступ через сервис-аккаунт',
  noAccess: 'Нет доступа к папке',
  treeStats: '{cities} городов · {projects} проектов',
  loading: 'Читаем папку Drive…',
  noProjects: 'В этом городе проектов нет',
  cityLabel: 'Город каталога',
  cityAuto: 'Определить автоматически',
  cityMissing:
    'Города этой папки нет в справочнике каталога — выберите его, иначе импорт остановится.',
  developerLabel: 'Застройщик',
  developerAuto: 'Из анкеты проекта',
  hasQuestionnaire: 'анкета есть',
  filesCount: 'файлов: {count}',
  foldersCount: 'папок: {count}',
  stages: {
    questionnaire: 'читаем анкету',
    draft: 'заводим черновик проекта',
    images: 'картинки {done} из {total}',
    sales: 'переносим цены и графики',
    done: 'завершаем',
  },
  emptyTitle: 'Проектов не нашлось',
  emptyHint: 'Проверьте, что папка «Database» расшарена на сервис-аккаунт импорта.',
  searchPlaceholder: 'Поиск проекта по названию',
  projectsCount: 'проектов: {count}',
  noQuestionnaire: 'нет анкеты',
  imported: 'импортирован',
  import: 'Импортировать',
  reimport: 'Обновить из Drive',
  openProject: 'Открыть проект',
  openDraft: 'Открыть черновик проекта',
  importMore: 'Импортировать ещё',
  linkPlaceholder: 'https://drive.google.com/drive/folders/…',
  importLink: 'Импортировать по ссылке',
  linkNoQuestionnaire: 'В папке нет анкеты VINPROP — перенесём только картинки',
  running: 'Импортируем «{name}»…',
  runningHint:
    'Картинки переносятся по одной, на большую папку уходит несколько минут. Страницу можно не закрывать.',
  done: 'Импорт завершён',
  doneToast: 'Проект импортирован — проверьте черновик',
  failed: 'Импорт не удался',
  unfinished: 'Незавершённые импорты',
  dismiss: 'Скрыть',
  dismissAll: 'Скрыть все',
  unfinishedHint: 'последние 25 запусков',
  retry: 'Повторить',
  timeout: 'Импорт идёт дольше обычного — проверьте статус позже',
  genericError: 'Не удалось выполнить импорт',
  facts: {
    images: 'Картинок перенесено',
    unitMix: 'Строк сводки типов',
    paymentPlans: 'Графиков платежей',
    developer: 'Застройщик',
    developerNew: 'заведён новый',
    developerFound: 'найден в каталоге',
  },
}

const enDriveImport = {
  title: 'Import projects from Google Drive',
  rootFolder: 'The «Database» folder',
  access: 'Access via service account',
  noAccess: 'No access to the folder',
  treeStats: '{cities} cities · {projects} projects',
  loading: 'Reading the Drive folder…',
  noProjects: 'No projects in this city',
  cityLabel: 'Catalog city',
  cityAuto: 'Detect automatically',
  cityMissing:
    "This folder's city is missing from the catalog — pick one, otherwise the import stops.",
  developerLabel: 'Developer',
  developerAuto: 'From the questionnaire',
  hasQuestionnaire: 'questionnaire found',
  filesCount: 'files: {count}',
  foldersCount: 'folders: {count}',
  stages: {
    questionnaire: 'reading the questionnaire',
    draft: 'creating the project draft',
    images: 'images {done} of {total}',
    sales: 'transferring prices and plans',
    done: 'finishing up',
  },
  emptyTitle: 'No projects found',
  emptyHint: 'Check that the «Database» folder is shared with the import service account.',
  searchPlaceholder: 'Search projects by name',
  projectsCount: 'projects: {count}',
  noQuestionnaire: 'no questionnaire',
  imported: 'imported',
  import: 'Import',
  reimport: 'Refresh from Drive',
  openProject: 'Open project',
  openDraft: 'Open project draft',
  importMore: 'Import another',
  linkPlaceholder: 'https://drive.google.com/drive/folders/…',
  importLink: 'Import from link',
  linkNoQuestionnaire: 'No VINPROP questionnaire in the folder — only images will be transferred',
  running: 'Importing «{name}»…',
  runningHint:
    'Images are transferred one by one; a large folder takes a few minutes. You can keep this page open.',
  done: 'Import finished',
  doneToast: 'Project imported — review the draft',
  failed: 'Import failed',
  unfinished: 'Unfinished imports',
  dismiss: 'Hide',
  dismissAll: 'Hide all',
  unfinishedHint: 'last 25 runs',
  retry: 'Retry',
  timeout: 'The import is taking longer than usual — check the status later',
  genericError: 'Could not run the import',
  facts: {
    images: 'Images transferred',
    unitMix: 'Unit mix rows',
    paymentPlans: 'Payment plans',
    developer: 'Developer',
    developerNew: 'created',
    developerFound: 'found in catalog',
  },
}

const vnDriveImport = {
  title: 'Nhập dự án từ Google Drive',
  rootFolder: 'Thư mục «Database»',
  access: 'Truy cập qua service account',
  noAccess: 'Không có quyền truy cập thư mục',
  treeStats: '{cities} thành phố · {projects} dự án',
  loading: 'Đang đọc thư mục Drive…',
  noProjects: 'Thành phố này chưa có dự án',
  cityLabel: 'Thành phố trong danh mục',
  cityAuto: 'Tự động xác định',
  cityMissing: 'Danh mục chưa có thành phố của thư mục này — hãy chọn, nếu không nhập sẽ dừng.',
  developerLabel: 'Chủ đầu tư',
  developerAuto: 'Theo biểu mẫu dự án',
  hasQuestionnaire: 'có biểu mẫu',
  filesCount: 'tệp: {count}',
  foldersCount: 'thư mục: {count}',
  stages: {
    questionnaire: 'đang đọc biểu mẫu',
    draft: 'đang tạo bản nháp dự án',
    images: 'hình ảnh {done} trên {total}',
    sales: 'đang chuyển giá và tiến độ',
    done: 'đang hoàn tất',
  },
  emptyTitle: 'Không tìm thấy dự án',
  emptyHint: 'Kiểm tra thư mục «Database» đã được chia sẻ cho service account chưa.',
  searchPlaceholder: 'Tìm dự án theo tên',
  projectsCount: 'dự án: {count}',
  noQuestionnaire: 'thiếu biểu mẫu',
  imported: 'đã nhập',
  import: 'Nhập',
  reimport: 'Cập nhật từ Drive',
  openProject: 'Mở dự án',
  openDraft: 'Mở bản nháp dự án',
  importMore: 'Nhập dự án khác',
  linkPlaceholder: 'https://drive.google.com/drive/folders/…',
  importLink: 'Nhập theo liên kết',
  linkNoQuestionnaire: 'Thư mục không có biểu mẫu VINPROP — chỉ chuyển hình ảnh',
  running: 'Đang nhập «{name}»…',
  runningHint:
    'Hình ảnh được chuyển lần lượt, thư mục lớn mất vài phút. Bạn có thể giữ trang này mở.',
  done: 'Đã nhập xong',
  doneToast: 'Đã nhập dự án — kiểm tra bản nháp',
  failed: 'Nhập thất bại',
  unfinished: 'Lần nhập chưa hoàn tất',
  dismiss: 'Ẩn',
  dismissAll: 'Ẩn tất cả',
  unfinishedHint: '25 lần chạy gần nhất',
  retry: 'Thử lại',
  timeout: 'Quá trình nhập lâu hơn thường lệ — kiểm tra trạng thái sau',
  genericError: 'Không thể thực hiện nhập',
  facts: {
    images: 'Hình ảnh đã chuyển',
    unitMix: 'Dòng bảng loại căn',
    paymentPlans: 'Tiến độ thanh toán',
    developer: 'Chủ đầu tư',
    developerNew: 'đã tạo mới',
    developerFound: 'có sẵn trong danh mục',
  },
}

/** DEV-1161. Передержка картинок импорта в блоке «Картинки» формы проекта. */
const ruTray = {
  title: 'Из импорта',
  pending: '{count} не разложено',
  fromFolder: '{folder} — из папки Drive',
  noFolder: 'Без папки',
  bannerHint: 'Пока без категории картинки не попадут ни на сайт, ни в карточку',
  open: 'Разложить картинки',
  deleteAll: 'Удалить все',
  deleteAllConfirm:
    'Удалить все {count} неразложенных картинок? Файлы будут стёрты из хранилища, вернуть их можно только повторным импортом папки.',
  sortTitle: 'Раскладка картинок',
  allFolders: 'Все',
  selected: 'Выбрано {count}',
  selectAll: 'Выделить все',
  sending: 'Отправляем картинки…',
  clearSelection: 'Снять выделение',
  removeSelected: 'Удалить',
  removeSelectedConfirm: 'Удалить {count} картинок? Файлы будут стёрты из хранилища безвозвратно.',
  dropCount: 'отправить {count}',
  full: 'занято',
  emptyFolder: 'В этой папке картинок не осталось',
  sortHint:
    'Перетащите миниатюру в категорию справа или выделите несколько и кликните по категории. Esc — закрыть',
  removeError: 'Не удалось удалить картинку',
  assignError: 'Не удалось перенести картинку в каталог',
  publishTitle: 'Опубликовать проект?',
  publishHint: 'Проект станет виден на сайте и в выдаче CRM.',
  publishAction: 'Опубликовать и удалить {count} картинок',
  cleanupConfirm:
    'В передержке осталось {count} неразложенных картинок — при публикации они будут удалены из облака. Повторный импорт папки Drive вернёт их.',
  cleanupError: 'Не удалось очистить передержку — проект не сохранён',
}

const enTray = {
  title: 'From import',
  pending: '{count} unsorted',
  fromFolder: '{folder} — from the Drive folder',
  noFolder: 'No folder',
  bannerHint: 'Without a category an image reaches neither the site nor the card',
  open: 'Sort images',
  deleteAll: 'Delete all',
  deleteAllConfirm:
    'Delete all {count} unsorted images? The files are erased from storage — only a re-import of the folder brings them back.',
  sortTitle: 'Sorting images',
  allFolders: 'All',
  selected: '{count} selected',
  selectAll: 'Select all',
  sending: 'Sending images…',
  clearSelection: 'Clear selection',
  removeSelected: 'Delete',
  removeSelectedConfirm: 'Delete {count} images? The files are erased from storage permanently.',
  dropCount: 'send {count}',
  full: 'full',
  emptyFolder: 'No images left in this folder',
  sortHint:
    'Drag a thumbnail onto a category on the right, or select several and click a category. Esc to close',
  removeError: 'Could not delete the image',
  assignError: 'Could not move the image into the catalog',
  publishTitle: 'Publish the project?',
  publishHint: 'The project becomes visible on the site and in CRM search.',
  publishAction: 'Publish and delete {count} images',
  cleanupConfirm:
    '{count} unsorted images are left in the import tray — publishing deletes them from storage. Re-importing the Drive folder brings them back.',
  cleanupError: 'Could not clear the import tray — project not saved',
}

const vnTray = {
  title: 'Từ nhập',
  pending: 'chưa phân loại: {count}',
  fromFolder: '{folder} — từ thư mục Drive',
  noFolder: 'Không có thư mục',
  bannerHint: 'Chưa có danh mục thì hình ảnh không lên website và không vào hồ sơ dự án',
  open: 'Phân loại hình ảnh',
  deleteAll: 'Xoá tất cả',
  deleteAllConfirm:
    'Xoá toàn bộ {count} hình ảnh chưa phân loại? Tệp sẽ bị xoá khỏi kho lưu trữ, chỉ nhập lại thư mục mới khôi phục được.',
  sortTitle: 'Phân loại hình ảnh',
  allFolders: 'Tất cả',
  selected: 'Đã chọn {count}',
  selectAll: 'Chọn tất cả',
  sending: 'Đang gửi hình ảnh…',
  clearSelection: 'Bỏ chọn',
  removeSelected: 'Xoá',
  removeSelectedConfirm: 'Xoá {count} hình ảnh? Tệp sẽ bị xoá vĩnh viễn khỏi kho lưu trữ.',
  dropCount: 'gửi {count}',
  full: 'đã đủ',
  emptyFolder: 'Thư mục này không còn hình ảnh',
  sortHint: 'Kéo ảnh vào danh mục bên phải hoặc chọn nhiều ảnh rồi bấm vào danh mục. Esc để đóng',
  removeError: 'Không thể xoá hình ảnh',
  assignError: 'Không thể chuyển hình ảnh vào danh mục',
  publishTitle: 'Xuất bản dự án?',
  publishHint: 'Dự án sẽ hiển thị trên website và trong tìm kiếm CRM.',
  publishAction: 'Xuất bản và xoá {count} hình ảnh',
  cleanupConfirm:
    'Còn {count} hình ảnh chưa phân loại — khi xuất bản chúng sẽ bị xoá khỏi kho. Nhập lại thư mục Drive sẽ khôi phục.',
  cleanupError: 'Không thể dọn phần nhập — dự án chưa được lưu',
}

export const driveImportMessages = {
  ru: { properties: { driveImport: ruDriveImport, form: { images: { tray: ruTray } } } },
  en: { properties: { driveImport: enDriveImport, form: { images: { tray: enTray } } } },
  vn: { properties: { driveImport: vnDriveImport, form: { images: { tray: vnTray } } } },
}
